var React = require('react');

function TemperatureHigh (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256 278.5V112a112 112 0 0 0-224 0v166.5C12.3 303.2 0 334 0 368a144 144 0 0 0 288 0c0-34-12.3-64.9-32-89.5zM144 448a79.87 79.87 0 0 1-48-143.8V112a48 48 0 0 1 96 0v192.2A79.87 79.87 0 0 1 144 448z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M416 0a96 96 0 1 0 96 96 96.15 96.15 0 0 0-96-96zm0 128a32 32 0 1 1 32-32 32 32 0 0 1-32 32zM160 322.9V112a16 16 0 0 0-32 0v210.9a48 48 0 1 0 32 0z","className":"fa-primary","key":2})]);
}

TemperatureHigh.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = TemperatureHigh;

TemperatureHigh.default = TemperatureHigh;
